import { MessageDescriptor } from "@lingui/core";
import { useLingui } from "@lingui/react";

import { isMessageDescriptor } from "../utils";

type TranslatableMessage = MessageDescriptor | string | undefined;

/**
 * Use this util in cases where you expect a variable to be either undefined or a valid string/MessageDescriptor 
 * 
 * Example: {getTranslatedMessage(providerContent.headerDescription) ??
            getTranslatedMessage(providerContent.shortDescription)}
            
 * @returns a translated string if param is a MessageDescriptor, otherwise return the string or undefined that was passed in
 */
const useTranslatedText = () => {
  const { _ } = useLingui();

  const isValidText = (text: unknown): text is TranslatableMessage =>
    isMessageDescriptor(text) ||
    typeof text === "string" ||
    typeof text === "undefined";

  const getTranslatedMessage = (
    text: TranslatableMessage,
  ): string | undefined => {
    if (isMessageDescriptor(text)) {
      return _(text);
    }

    return text;
  };

  return { getTranslatedMessage, isValidText };
};

export default useTranslatedText;
